module.exports = {
  BASE_URL: "https://s6.budding.ai/api/",
  CLIENT: "api-client",
  SECRET: "MQbolnen2m6c3mb9HCcoXQGS0yBj5GEM",
  PDF_FILE_SIZE: 10000000,
};
